import { i18n } from 'next-i18next'

export default function handleStripeErrorMessage(declineCode: string | undefined) {
  const t = i18n?.t.bind(i18n) || ((_key: string, fallback: string) => fallback)

  let errorMessage = t(
    'Stripe.errors.default',
    'An error has occurred while trying to finalize your payment.',
  )

  switch (declineCode) {
    case 'generic_decline':
      errorMessage = t('Stripe.errors.genericDecline', 'Your card was declined, please try again.')
      break
    case 'insufficient_funds':
      errorMessage = t(
        'Stripe.errors.insufficientFunds',
        'Your card has insufficient funds, please try again.',
      )

      break
    case 'expired_card':
      errorMessage = t('Stripe.errors.cardExpired', 'Your card has expired, please try again.')
      break
    case 'incorrect_cvc':
      errorMessage = t(
        'Stripe.errors.incorrectCVC',
        "Your card's security code is incorrect, please update and try again.",
      )

      break
    case 'processing_error':
      errorMessage = t(
        'Stripe.errors.processingError',
        'An error occurred while processing your card. Please try again in a little bit.',
      )

      break
    case 'card_velocity_exceeded':
      errorMessage = t(
        'Stripe.errors.cardVelocityExceeded',
        'Your card was declined for making repeated attempts too frequently or exceeding its amount limit. Please try again in a little bit.',
      )

      break

    case 'authentication_required':
    case 'payment_intent_authentication_failure':
      errorMessage = t(
        'Stripe.errors.authenticationRequired',
        'Card authentication failed. Please try again or choose a different payment method.',
      )

      break

    default:
      break
  }

  return errorMessage
}
